// src/components/Login.tsx
import React, { useEffect, useState } from 'react';
import './login.css';
import loginBackground from '../../assets/images/bg.svg';
import logo from '../../assets/images/logo-icon.png';
import LoginService from './login-service';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const SessionTimeout: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [error, setError] = useState<string | null>(null);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isReady, setIsReady] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        navigate('/login');
    };

    return (
        <div className="login-container" style={{ backgroundColor: '#ffffffff' }}>
            <form onSubmit={handleLogin} className="login-form">
                {/* <div style={{ textAlign: 'center' }}> */}
                <img src={logo} alt="Logo" style={{ width: '350px', height: 'auto' }} />
                {/* </div> */}
                {/* <h1>{process.env.REACT_APP_SYSTEM_NAME}</h1> */}
                <div className="session-box">
                    <p>Your session has timed out due to inactivity.<br />Please log in again to continue.</p>
                </div>
                <div className="form-group">
                    <Button
                        disabled={isLoading}
                        className="login-button"
                        type="submit"
                        color="primary"
                    >
                        {isLoading ? "Logging in..." : "Proceed To Login"}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default SessionTimeout;
